import { createClient } from '@supabase/supabase-js';

const rawUrl = (process.env.REACT_APP_SUPABASE_URL || '').trim();
const rawKey = (process.env.REACT_APP_SUPABASE_ANON_KEY || '').trim();

/**
 * Check if the Supabase environment is properly configured with a real project.
 * @returns {boolean}
 */
export function isSupabaseConfigured() {
  if (!rawUrl || !rawKey) return false;
  if (
    rawUrl.includes('placeholder.supabase.co') ||
    rawUrl.includes('your-project.supabase.co') ||
    rawUrl.includes('unconfigured')
  ) {
    return false;
  }
  if (
    rawKey === 'placeholder-anon-key' ||
    rawKey === 'your-anon-key-here' ||
    rawKey === 'unconfigured-anon-key'
  ) {
    return false;
  }
  try {
    const parsed = new URL(rawUrl);
    return parsed.protocol === 'https:' || parsed.protocol === 'http:';
  } catch {
    return false;
  }
}

const configured = isSupabaseConfigured();

if (!configured) {
  console.warn(
    '[SenritsuX] Supabase is not yet configured with a valid project URL and Anon Key.\n' +
    'Please create or update your `frontend/.env` file with:\n' +
    '  REACT_APP_SUPABASE_URL=https://<your-project-ref>.supabase.co\n' +
    '  REACT_APP_SUPABASE_ANON_KEY=<your-anon-key>'
  );
}

// Initialize Supabase Client with valid configuration or safe fallback target
const targetUrl = configured ? rawUrl : 'https://unconfigured.supabase.co';
const targetKey = configured ? rawKey : 'unconfigured-anon-key';

export const supabase = createClient(targetUrl, targetKey, {
  auth: {
    autoRefreshToken: configured,
    persistSession: configured,
    detectSessionInUrl: configured,
  },
});

// Development-only diagnostic logging (Strictly excludes anon key & secrets)
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  console.info('[SenritsuX Auth]', {
    origin: window.location.origin,
    supabaseUrl: targetUrl,
    callbackUrl: `${window.location.origin}/auth/callback`,
  });
}

